'use strict';

module.exports = '3.22.6';
